import React from 'react';
import { Button } from './ui/button';
import { X, RotateCcw } from 'lucide-react';
import { QueryGroup, RandomCompany } from '../types/randomCompanies';

interface QueryGroupsProps {
  queryGroups: QueryGroup[];
  companies: RandomCompany[];
  onUndoGroup: (groupId: string) => void;
  onSearchAgain?: (query: string) => void;
  onGroupHover?: (groupId: string | null) => void;
}

export const QueryGroups: React.FC<QueryGroupsProps> = ({ 
  queryGroups, 
  companies, 
  onUndoGroup,
  onSearchAgain,
  onGroupHover
}) => {
  if (queryGroups.length === 0) return null;

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-slate-300">Query Groups:</h3>
      <div className="flex flex-wrap gap-2">
        {queryGroups.map(group => {
          const groupCompanies = companies.filter(c => c.groupId === group.id);
          const votedInGroup = groupCompanies.filter(c => c.voted).length;
          
          return (
            <div
              key={group.id}
              className="flex items-center gap-2 bg-slate-700 rounded-lg px-3 py-2 text-sm hover:bg-slate-600 transition-colors cursor-pointer"
              onMouseEnter={() => onGroupHover?.(group.id)}
              onMouseLeave={() => onGroupHover?.(null)}
            >
              <span className="text-slate-300">
                "{group.query}" ({groupCompanies.length} companies, {votedInGroup} voted)
              </span>
              {onSearchAgain && (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    onSearchAgain(group.query);
                  }}
                  size="sm"
                  variant="ghost"
                  className="h-6 w-6 p-0 text-slate-400 hover:text-white hover:bg-slate-600"
                  title="Search again"
                >
                  <RotateCcw className="w-3 h-3" />
                </Button>
              )}
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  onUndoGroup(group.id);
                }}
                size="sm"
                variant="ghost"
                className="h-6 w-6 p-0 text-slate-400 hover:text-white hover:bg-slate-600"
                title="Remove group"
              >
                <X className="w-3 h-3" />
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}; 